import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import { VariantTraitModel } from "@insite/client-framework/Types/ApiModels";

const useSwatchSelectedAccessibleText = (variantTrait: VariantTraitModel) => {
    const variantSelection = useAppSelector(state => state.pages.productDetails.variantSelection);
    const variantTraitSelected = variantTrait.traitValues?.find(
        x => variantSelection[variantTrait.id] === x.id,
    )?.valueDisplay;

    return variantTraitSelected ? `${variantTraitSelected} ${translate("Selected")}` : undefined;
};

export default useSwatchSelectedAccessibleText;
